import React, { useState } from 'react';

import { Button, Card } from 'react-bootstrap';

import CandidateFillModal from './common/CandidateFillModal';
import ExclamationTriangle from '../../../assets/svg/ExclamationTriangle';

const CandidateFolderComponent = (props: any) => {
  const [showFillModal, setShowFillModal] = useState(false);

  return (
    <>
      <Card className="w-75 p-4 mx-auto">
        <Card.Header className="bg-white">
          <div className="title-h5">Mon dossier de location</div>
          <div className="text-muted text-start">
            Envoyez ici vos documents ainsi que ceux de vos colocataires et/ou garants.
          </div>
        </Card.Header>
        <Card.Body>
          <div className="subtitle-2 text-muted text-start fw-bold text-wrap text-break mt-4 mb-4">
            Situation professionnelle
          </div>
          <div className="rounded-3 p-2 px-lg-4 mt-1 peach-background mt-2 mb-4">
            <div className="modal-body d-flex flex-row d-flex justify-content-start flex-wrap p-4 gap-4">
              <ExclamationTriangle color="#E90117" w={'32'} />
              <div className="modal-body d-flex flex-column d-flex justify-content-start p-0 gap-3">
                <div className="mt-2 subtitle-2 text-muted text-start fw-bold text-break">
                  Situation professionnelle non renseignée
                </div>
                <div className="mt-0 subtitle-2 text-muted text-start text-break">
                  Afin de débuter la constitution de votre dossier de location, veuillez indiquer le nombre de
                  colocataires ainsi que leur situation profesionnelle. Vous saurez quels documents envoyer.
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex flex-row gap-2 flex-wrap">
            <Button
              type="button"
              variant="primary"
              role="button"
              className="mb-4"
              onClick={() => setShowFillModal(true)}
            >
              Renseigner les informations
            </Button>
            <Button className="mb-4" variant="outline-primary" role="button" onClick={() => props.setStep(2)}>
              Voir rendez-vous
            </Button>
          </div>
          <CandidateFillModal show={showFillModal} setShow={setShowFillModal} />
        </Card.Body>
      </Card>
    </>
  );
};

export default CandidateFolderComponent;
